<template>
  <b-table class="sticky-table-header" :data="operators" narrowed hoverable>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <b-table-column
      field="name"
      :label="$t('operators.name')"
      sortable
      v-slot="props"
    >
      {{ props.row.personalInfo.name }}
    </b-table-column>

    <b-table-column
      field="email"
      :label="$t('operators.email')"
      sortable
      v-slot="props"
    >
      {{ props.row.personalInfo.email }}
    </b-table-column>

    <b-table-column
      field="cellphone"
      :label="$t('common.cellphone')"
      sortable
      v-slot="props"
    >
      {{
        `${props.row.personalInfo.countryCallingCode} ${props.row.personalInfo.cellphone}`
      }}
    </b-table-column>

    <b-table-column :label="$t('operators.status')" v-slot="props">
      <b-switch
        size="is-small"
        class="switch"
        type="is-primary"
        v-model="props.row.accountInfo.isAccountActive"
        passive-type="is-secondary"
        @input="changeOperatorStatus(props.row)"
      ></b-switch>

      {{
        props.row.accountInfo.isAccountActive
          ? $t("common.Active")
          : $t("common.Inactive")
      }}
    </b-table-column>

    <b-table-column :label="$t('operators.edit')" v-slot="props">
      <button class="button is-small" @click="editOperator(props.row)">
        <b-icon icon="edit" type="is-dark"></b-icon>
      </button>
    </b-table-column>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="sad-cry" size="is-large"></b-icon>
          </p>
          <p>{{ $t("common.tableEmptyMessage") }}</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import { common } from "../../mixins/common";

export default {
  props: ["operators"],

  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    editOperator(operator) {
      this.$emit("edit-operator", operator);
    },

    changeOperatorStatus(operator) {
      this.isLoading = true;
      this.$store
        .dispatch("changeOperatorStatus", {
          operatorId: operator._id,
          status: operator.accountInfo.isAccountActive
        })
        .then(res => {
          if (res.data.result === "error") {
            operator.accountInfo.isAccountActive = !operator.accountInfo
              .isAccountActive;
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: `${this.$t("operators.statusUpdated")}!`,
              type: "is-success",
              position: "is-bottom"
            });
          }
        })
        .catch(() => {
          operator.accountInfo.isAccountActive = !operator.accountInfo
            .isAccountActive;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
